import React from "react";
import moment from "moment";
import {AppBar, Box, Card, CardContent, CardHeader, Chip, Container, FormControl, IconButton, InputLabel, List, ListItem, MenuItem, Select, Toolbar, Typography} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import SlideDatepicker from "./SlideDatepicker";
import {getDayShiftsSchedules} from "../../api/client";

export default function DayDrawer(props) {
  const [state, setState] = React.useState({
    ...props.state,
    date: props.date.format("yyyy-MM-DD")
  })
  const closeOpen = () => {
    props.setState({...props.state, stffNos: state.stffNos, jgCd: state.jgCd});
    props.setOpen([false, props.date]);;
  };

  React.useEffect(() => {
    getDayShiftsSchedules({ymd_dt: state.date, stffNoList: state.stffNos}).then(response => {
      setState({...state, data: {...state.data, ...response.data}});
    }).catch(error => {
      props.setToastState({...props.toastState, error: true, message: Boolean(error.response && error.response.data) ? error.response.data.errors[0] : null, networkError: !Boolean(error.response && error.response.data)});
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.date, state.stffNos]);

  return (
    <Container
      maxWidth = "sm"
      sx = {{padding: 2, pt: 0, flexGrow: 1}}
    >
      <Box
        position = "sticky"
        sx = {{top: 0, zIndex: 1}}
      >
        <AppBar
          className = "bgcolor-white"
          position = "static"
        >
          <Toolbar
            sx = {{p: 0}}
          >
            <IconButton
              aria-label = "menu"
              color = "default"
              onClick = {closeOpen}
              size = "small"
              sx = {{ml: "auto"}}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </Box>
      <Box
        className = "bgcolor-white"
        position = "sticky"
        sx = {{top: 55, pt: 2, textAlign: "center", zIndex: 1}}
      >
        <SlideDatepicker
          setState = {setState}
          state = {state}
          ymdFg = {true}
        />
        <List>
          <ListItem>
            <FormControl
              size = "small"
              sx = {{width: "100%"}}
            >
              <InputLabel
                id = "stff_list_label"
                sx = {{zindex: 2}}
              >
                事業所
              </InputLabel>
              <Select
                autoWidth
                id = "jg_list"
                label = "事業所"
                labelId = "jg_list_label"
                MenuProps = {{PaperProps: {style: {maxHeight: 200}}}}
                onChange = {(e) => setState({...state, jgCd: e.target.value})}
                value = {state.jgCd}
              >
                {props.state.data.jgList.map((jg) => (
                  <MenuItem
                    key = {"jg" + jg[0]}
                    value = {jg[0]}
                  >
                    {jg[1]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </ListItem>
          <ListItem>
            <FormControl
              size = "small"
              sx = {{width: "100%"}}
            >
              <InputLabel
                id = "stff_list_label"
                sx = {{zindex: 2}}
              >
                職員
              </InputLabel>
              <Select
                autoWidth
                endAdornment = {
                  <IconButton
                    onClick = {() => setState({...state, stffNos: [state.data.stffNo]})}
                  >
                    <CancelIcon
                      fontSize = "small"
                    />
                  </IconButton>}
                id = "stff_list"
                IconComponent = {() => null}
                label = "職員"
                labelId = "stff_list_label"
                MenuProps = {{PaperProps: {style: {maxHeight: 200}}}}
                multiple
                onChange = {(e) => setState({...state, stffNos: e.target.value})}
                renderValue = {(selected) => (
                  <Box
                    sx = {{display: "flex", flexWrap: "wrap", gap: 0.5}}
                  >
                    {selected.map((value) => (
                      <Chip
                        key = {value}
                        label = {props.state.data.stffList.filter(stff => stff[0] === value)[0][1]}
                        sx = {{fontSize: "1rem"}}
                      />
                    ))}
                  </Box>
                )}
                SelectDisplayProps = {{className: "multiple-select"}}
                sx = {{p: 0}}
                value = {state.stffNos}
              >
                {props.state.data.stffList.filter(stff => stff[2].includes(state.jgCd)).map((stff) => (
                  <MenuItem
                    key = {"stff" + stff[0]}
                    value = {stff[0]}
                  >
                    {stff[1]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </ListItem>
        </List>
      </Box>
      <Box
        sx = {{display: "flex", overflowX: "scroll"}}
      >
      {props.state.data.stffList.filter(stff => stff[0] === sessionStorage.getItem("stffNo") || (stff[2].includes(state.jgCd) && state.stffNos.includes(stff[0]))).map(stff => stff[0]).map((stffNo) => (
        <Box
          key = {"stffNo" + stffNo}
          sx = {{width: "47%", m: 0.5, flexShrink: 0}}
        >
          <Card
            key = {"shifts-schedules" + stffNo}
            variant = "outlined"
          >
            <CardHeader
              className = "btn-select"
              sx = {{p: 1.6}}
              title = {props.state.data.stffList.filter(stff => stff[0] === stffNo)[0][1]}
              titleTypographyProps = {{className: "title"}}
            />
            {state.data[moment(state.date).format("D")][stffNo] &&
            state.data[moment(state.date).format("D")][stffNo][0].map((data, i) => (
              <CardContent
                className = "btn-select"
                key = {"shift" + stffNo + i}
                sx = {{p: 1.6}}
              >
                <Typography
                  sx = {{fontSize: "1.0rem"}}
                >
                  {!Boolean(parseInt(data.ptoStatus)) ? data.nm || "----" : data.ptoStatus === "1" ? "休暇申請中" : "休暇"}
                </Typography>
                <Typography
                  sx = {{fontSize: "1.0rem"}}
                >
                  {!Boolean(parseInt(data.ptoStatus)) ? (data.timef || "--:--") + " ~ " + (data.timet || "--:--") : ""}
                </Typography>
              </CardContent>
            ))}
            {sessionStorage.getItem("stffNo") === stffNo &&
            state.data[moment(state.date).format("D")][stffNo] &&
            state.data[moment(state.date).format("D")][stffNo][1].map((data, j) => (
              <CardContent
                key = {"schedule" + stffNo + j}
                sx = {{p: 1.6, pt: 3, pb: 2}}
              >
                {!Boolean(data.timelessOtherFg) &&
                <Typography
                  sx = {{fontSize: "1.0rem"}}
                >
                  {(data.timef || "--:--") + " ~ " + (data.timet || "--:--")}
                </Typography>}
                <Typography
                  sx = {{fontSize: "1.0rem"}}
                >
                  {data.nm}
                </Typography>
                <Typography
                  sx = {{fontSize: "0.94rem"}}
                >
                  {data.svRnm}
                </Typography>
              </CardContent>
            ))}
          </Card>
        </Box>
      ))}
      </Box>
    </Container>
  );
};
